// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__ibmS0","icone":"Alert_icone__IXB2W","texto":"Alert_texto__ZEb3o","warning":"Alert_warning__AeMZe"};